import { BrowserRouter as Router, Switch } from 'react-router-dom';
import Route from './Route';
import Login from '../pages/Login';
import Register from '../pages/Register';
import Main from '../pages/Main';
import Result from '../pages/Result';

const Routes = () => (
  <Router>
    <Switch>
      <Route exact path="/login" component={Login} />
      <Route exact path="/register" component={Register} />
      <Route exact path="/" component={Main} isPrivate />
      <Route exact path="/result" component={Result} isPrivate />
    </Switch>
  </Router>
);

export default Routes;
